import { Container } from "aurelia-dependency-injection";
import { CaseDocumentModel } from "./../models/case-document";
import { CaseDownloadView } from "./partials/case-download";
import { GenericDocumentView } from "./generic-document";
import { MobileHelper} from "../../shared/helpers/mobile-helper";
import {DesktopModel} from "../../desktop/models/desktop";

const warningIcon = `<i class="icon fa fa-exclamation-circle" aria-hidden="true" title="Heard in a higher court"></i>`;
const dom = {
        DOCUMENT_NAVIGATION: ".document-navigator",
        STAGE_ALERT: ".stage-alert",
        DOCUMENT_ALERT: ".document-alert",
        MOBILE_REQUEST_ALL_RELATIONS: ".mobile-request-all-relations",
        MOBILE_HIDDEN_NEUTRAL_TREATMENTS_ALERT: ".mobile-hidden-neutral-treatments-alert",
        PANEL_SWITCHER: ".switch-button",
        STAGE_SELECTOR: ".stage-selected"
};

export class CaseDocumentView extends GenericDocumentView {

        public model: CaseDocumentModel;
        private mobileHelper: MobileHelper = Container.instance.get(MobileHelper);
        private desktopModel: DesktopModel = Container.instance.get(DesktopModel);

        public onShow() {
                super.onShow();
                this.setupModelEvents();
                this.setupStageSelector();
                this.setupDocumentAlert();
        }

        public setupModelEvents() {
                this.listenTo(this.desktopModel, "change:MultipleMode", this.setupDocumentAlert);
                this.listenTo(this.desktopModel, "change:MultipleMode", this.setupStageSelector);
        }

        public events(): Backbone.EventsHash {
                const events: Backbone.EventsHash = super.events();
                events["click " + dom.STAGE_ALERT] = (e) => this.stageAlertClicked(e);
                const mh: MobileHelper = Container.instance.get(MobileHelper); // Can't use the class reference to this, guess that code hasn't run to initialise it at this point
                return events;
        }

        protected setupDownloadView() {
                const downloadTemplate = this.templateManager.getTemplate("download-case", this.model.DocumentAccessSku);
                downloadTemplate.then((template) => {
                        this.downloadView = new CaseDownloadView({model: this.model, template: template.Raw});
                        this.downloadView.template = template.Raw;
                        this.downloadRegion.show(this.downloadView);
                });
        }

        private setupStageSelector() {
                if (this.desktopModel.MultipleMode) {
                        this.$(dom.STAGE_SELECTOR).addClass("stage-selected-multimode");
                } else {
                        this.$(`${dom.STAGE_SELECTOR}`).removeClass("stage-selected-multimode");
                }
        }

        private setupDocumentAlert() {
                let message = "";
                if (!this.model.IsHighestStage) {
                        message += `<span class="stage-alert">${warningIcon}<span class="stage-alert-message-${this.desktopModel.MultipleMode ? "multimode" : "singlemode"}"> Heard in a higher court.  </span></span>`;
                }
                const overruled = this.model.Subsequent.where((s) => s.Treatment.Name.toLowerCase() === "overruled")[0];
                if (overruled) {
                        const year = overruled.Year;
                        const url = `case/${this.model.FriendlyUrlTitle}/subsequent-cases/${this.model.Id}`;
                        const link = `<a class="document-link overruled" href="${url}">${warningIcon}Overruled in ${year}</a>`;
                        message += link;
                }
                if (message) {
                        this.$(dom.DOCUMENT_ALERT).show();
                        this.$(dom.DOCUMENT_ALERT).html(message);
                } else {
                        this.$(dom.DOCUMENT_ALERT).hide();
                }
        }

        private stageAlertClicked(e: JQueryEventObject): void {
                e.stopPropagation();
                this.$(dom.DOCUMENT_NAVIGATION).find(".dropdown-toggle").dropdown("toggle");
        }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/case-document.ts